export const typography = {
  fonts: {
    sans: "'Inter', sans-serif",
    heading: "'Poppins', sans-serif",
    mono: "'Robotto', monospace",
  },
};

export const lightTheme = {
  colors: {
    primary: "#060E4D",
    primaryForeground: "#ffffff",
    primaryHover: "#1d2a7a",

    secondary: "#ffffff",
    secondaryForeground: "#060E4D",
    secondaryHover: "#f3f4f6",

    background: "#ffffff",
    foreground: "#060E4D",

    card: "#F4F5F5",
    cardForeground: "#273135",
    cardHover: "#e8ebec",

    muted: "#DCE7F7",
    mutedForeground: "#060E4D",
    mutedHover: "#c7daf2",

    accent: "#88A8ED",
    accentForeground: "#ffffff",

    input: "#ffffff",
    border: "#DCDCDC",

    text: "#060E4D",
    textMuted: "#88A8ED",
    textInverted: "#ffffff",
    textPlaceholder: "#9ca3af",
    textDisabled: "#888888",

    // State Colors
    success: "#10b981",
    warning: "#f59e0b",
    error: "#C72438",
    info: "#0ea5e9",

    shadow: "-5.1px 5.1px 34.45px 0px #0000000D",
  },
  ...typography,
};

export const defaultColorTheme = {
  primary: { hex: "#060e4d", hsl: "233 86% 16%" },
  primaryForeground: { hex: "#ffffff", hsl: "0 0% 100%" },
  primaryHover: { hex: "#1d2a7a", hsl: "232 58% 30%" },

  secondary: { hex: "#ffffff", hsl: "0 0% 100%" },
  secondaryForeground: { hex: "#060e4d", hsl: "233 86% 16%" },
  secondaryHover: { hex: "#f3f4f6", hsl: "220 14% 96%" },

  background: { hex: "#ffffff", hsl: "0 0% 100%" },
  foreground: { hex: "#060e4d", hsl: "233 86% 16%" },

  card: {
      hex: "#f4f5f5",              
      hsl: "210 9% 96%", 
    },
  cardHover :  { hex: "#e8ebec", hsl: "210 8% 92%" },
  cardForeground: { hex: "#273135", hsl: "202 14% 18%" },
  cardBackground: { hex: "#fcfbfa", hsl: "30 33% 98%" },

  muted: { hex: "#dce7f7", hsl: "214 58% 91%" },
  mutedForeground: { hex: "#060e4d", hsl: "233 86% 16%" },
  mutedHover: { hex: "#c7daf2", hsl: "214 56% 88%" },

  accent: { hex: "#88a8ed", hsl: "221 72% 76%" },
  accentForeground: { hex: "#ffffff", hsl: "0 0% 100%" },
  accentBackground: { hex: "#e6effc", hsl: "216 76% 94%" },

  input: { hex: "#ffffff", hsl: "0 0% 100%" },
  border: { hex: "#dcdcdc", hsl: "0 0% 86%" },

  text: {
    primary: { hex: "#060e4d", hsl: "233 86% 16%" },
    secondary: { hex: "#ffffff", hsl: "0 0% 100%" },
    muted: { hex: "#88a8ed", hsl: "221 72% 76%" },
    inverted: { hex: "#ffffff", hsl: "0 0% 100%" },
    placeholder: { hex: "#9ca3af", hsl: "220 9% 70%" },
    disabled: { hex: "#888888", hsl: "0 0% 53%" },
    primaryButton: { hex: "#0b1776", hsl: "235 83% 26%" },
    primaryButtonForeground: { hex: "#ffffff", hsl: "0 0% 100%" },
    black: { hex: "#000000", hsl: "0 0% 0%" },
    quaternary: { hex: "#273135", hsl: "202 14% 18%" }
  },

  state: {
    success: { hex: "#10b981", hsl: "158 64% 47%" },
    warning: { hex: "#f59e0b", hsl: "38 92% 60%" },
    error: { hex: "#c72438", hsl: "348 69% 46%" },
    info: { hex: "#0ea5e9", hsl: "199 86% 54%" }
  },

  shadow: {
    default: "-5.1px 5.1px 34.45px 0px #0000000d"
  },

  font: {
    sans: "Inter",
    heading: "Poppins",
    mono: "Roboto Mono",
    fallback: "sans-serif",
    primary: "Frutiger",
    secondary: "Cph"
  }
};
